import { cn } from "@/lib/components";
import Link from "next/link";

export function Nav(props: React.HTMLAttributes<HTMLUListElement>) {
  return (
    <nav>
      <ul {...props} />
    </nav>
  );
}

Nav.Item = function NavItem({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <li className={cn("flex cursor-pointer hover:opacity-70", className)}>
      {children}
    </li>
  );
};

Nav.Link = function NavLink({
  children,
  href,
  className,
}: {
  children: React.ReactNode;
  href: string;
  className?: string;
}) {
  return (
    <Nav.Item className={className}>
      <Link href={href} className={className}>
        {children}
      </Link>
    </Nav.Item>
  );
};
